import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const useTokenMonitor = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkToken = () => {
      if (!localStorage.getItem('token')) {
        navigate('/admin/login', { replace: true });
      }
    };

    // Check immediately
    checkToken();

    // Set up interval to check token
    const interval = setInterval(checkToken, 1000);

    return () => clearInterval(interval);
  }, [navigate]);
};

export default useTokenMonitor;